import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _templateObject;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BlueElement, register as blueRegister } from '@onviobr/element';
import { styles } from './busy-loader.css';
var BusyLoader = /*#__PURE__*/function (_BlueElement) {
  function BusyLoader() {
    _classCallCheck(this, BusyLoader);
    return _callSuper(this, BusyLoader, arguments);
  }
  _inherits(BusyLoader, _BlueElement);
  return _createClass(BusyLoader, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t<svg class=\"busy-loader-svg\" viewBox=\"0 0 75 75\">\n\t\t\t\t<path d=\"M39.331 67.444a30 30 0 0018.048-7.475\"></path>\n\t\t\t\t<path d=\"M59.969 57.379a30 30 0 007.475-18.048\"></path>\n\t\t\t\t<path d=\"M67.444 35.669a30 30 0 00-7.475-18.048\"></path>\n\t\t\t\t<path d=\"M57.379 15.031A30 30 0 0039.33 7.556\"></path>\n\t\t\t\t<path d=\"M35.669 7.556a30 30 0 00-18.048 7.475\"></path>\n\t\t\t\t<path d=\"M15.031 17.621A30 30 0 007.556 35.67\"></path>\n\t\t\t\t<path d=\"M7.556 39.331a30 30 0 007.475 18.048\"></path>\n\t\t\t\t<path d=\"M17.621 59.969a30 30 0 0018.048 7.475\"></path>\n\t\t\t</svg>\n\t\t"])));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'busy-loader';
    }
  }, {
    key: "styles",
    get: function get() {
      return styles;
    }
  }]);
}(BlueElement);
export { BusyLoader as default };
export var registerBusyLoader = function registerBusyLoader() {
  return blueRegister(BusyLoader);
};
